import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import { INoteCorrection } from './interface';
import NoteCorrectionForm from './NoteCorrectionForm';
import NoteCorrectionSuccess from './NoteCorrectionSuccess';
import './styles.scss';

const NoteCorrection: React.FC<INoteCorrection> = () => {
  const [requestSuccess, setRequestSuccess] = useState(false);
  const [protocolNumber, setProtocolNumber] = useState('');
  const slider = useSelector((state: RootState) => state.slider);

  return (
    !requestSuccess ?
      <NoteCorrectionForm
        order={slider?.data[0]}
        setRequestSuccess={setRequestSuccess}
        setProtocolNumber={setProtocolNumber} />
      :
      <NoteCorrectionSuccess protocolNumber={protocolNumber} />
  );
};

export default NoteCorrection;